import * as React from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import {TextValidator} from "react-material-ui-form-validator"
import {Autocomplete, IconButton} from "@mui/material"
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import {red} from "@mui/material/colors"

const PackageProviderRow = ({serviceTypeChoices, index, formValues, setFormValues, removeRow}) => {
  const handleServiceTypeChange = (event, value) => {
    formValues.package_providers[index].service_type = value
    setFormValues({...formValues, package_providers: formValues.package_providers})
  }

  const handleQuantityChange = (event) => {
    formValues.package_providers[index].quantity = event.target.value
    setFormValues({...formValues, package_providers: formValues.package_providers})
  }

  const handleDisplayQuantityChange = (event) => {
    formValues.package_providers[index].display_quantity = event.target.value
    setFormValues({...formValues, package_providers: formValues.package_providers})
  }

  return (
    <TableRow
      key={`package_provider_table_row_${index}`}
      sx={{'&:last-child td, &:last-child th': {border: 0}}}
    >
      <TableCell>
        <Autocomplete
          disablePortal
          options={serviceTypeChoices.map(choice => choice.value)}
          onChange={handleServiceTypeChange}
          value={formValues.package_providers[index].service_type}
          getOptionLabel={(option) => {
            let choice = serviceTypeChoices.find((item) => item.value === option)
            return choice ? choice.label : ''
          }}
          renderInput={(params) => (
            <TextValidator
              {...params}
              name={'service_type'}
              label="Service Type"
              placeholder={'Service Type'}
              value={formValues.package_providers[index].service_type}
              validators={['required']}
              errorMessages={['This field is required']}
            />
          )}
        />
      </TableCell>

      <TableCell>
        <TextValidator
          placeholder={'Quantity'}
          name={`quantity_${index}`}
          variant={'outlined'}
          fullWidth={true}
          validators={['required']}
          errorMessages={['This field is required']}
          onChange={handleQuantityChange}
          value={formValues.package_providers[index].quantity}
          type={'number'}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell>
        <TextValidator
          placeholder={'Display Quantity'}
          name={`display_quantity_${index}`}
          variant={'outlined'}
          fullWidth={true}
          validators={['required']}
          errorMessages={['This field is required']}
          onChange={handleDisplayQuantityChange}
          value={formValues.package_providers[index].display_quantity}
          type={'number'}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell align="center">
        <IconButton onClick={() => {
          removeRow(index)
        }}>
          <DeleteOutlineIcon sx={{color: red[500]}}/>
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default PackageProviderRow
